import * as THREE from 'three';

/**
 * Computes the area of a polygon using the shoelace formula.
 * @returns
 */
export const shoelaceArea = (points: THREE.Vector2[]) => {
  let area = 0;
  for (let i = 0; i < points.length; i++) {
    const j = (i + 1) % points.length;
    area += points[i].x * points[j].y - points[j].x * points[i].y;
  }
  return 0.5 * area;
};
